var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalBookedSlots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 16.1H20.7V2.3H18.4V10.35L15.525 8.625L12.65 10.35V2.3H6.9V16.1ZM6.9 18.4C6.2675 18.4 5.72585 18.1746 5.27505 17.7238C4.82425 17.273 4.59923 16.7317 4.6 16.1V2.3C4.6 1.6675 4.8254 1.12585 5.2762 0.675052C5.727 0.224252 6.26827 -0.000764714 6.9 1.95246e-06H20.7C21.3325 1.95246e-06 21.8741 0.225402 22.3249 0.676202C22.7757 1.127 23.0008 1.66827 23 2.3V16.1C23 16.7325 22.7746 17.2741 22.3238 17.7249C21.873 18.1757 21.3317 18.4008 20.7 18.4H6.9ZM2.3 23C1.6675 23 1.12585 22.7746 0.675052 22.3238C0.224252 21.873 -0.000764714 21.3317 1.95246e-06 20.7V4.6H2.3V20.7H18.4V23H2.3Z",
    fill: "#46565C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBookedSlots);
export default __webpack_public_path__ + "static/media/Total_booked_slots.a0b2157d9dae242ae83cfafac6a48e69.svg";
export { ForwardRef as ReactComponent };